export default "__VITE_ASSET__0a6570bb__"